module.exports = __webpack_public_path__ + "static/img/Kyle-Flanagan.24ea41c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Kyle-Flanagan.jpg
// module id = xaPt
// module chunks = 0